import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Row, Col, Form, Input, Select, message, DatePicker, Table, Spin, Space, Drawer, Modal } from 'antd';
import PropTypes from 'prop-types';
import moment from 'moment';
import "moment-timezone";
import { Scrollbars } from 'react-custom-scrollbars';
import { pdf, PDFViewer } from '@react-pdf/renderer'
import { useDispatch, useSelector } from 'react-redux';
import { PlusCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { useHistory } from "react-router-dom";
import { getContactDatabyAccount, QuotesItemListColumn, getDealDatabyAccount } from './Functions/quotesFunctions';
import QuotationPdf from './PdfComponents/InvoicePdf';
import DetailsPage from '../Pages/DetailsPage/Detailspage';
import QuotesFields from '../Pages/DetailsPage/InvoiceFields'
import QuotesRight from '../Pages/DetailsPage/InvoiceRight'
import { RelatedDocUpload } from '../Pages/GlobalComponents/RelatedDocUpload'
import { FetchContactDetails } from '../../../Api/Services/ContactApiService'
import { getCompanyInvoice, findOneByInvoice, deleteInvoice, updateInvoice, createInvoice } from '../../../Api/Services/InvoiceApiServiec'
import { FetchAllAccount } from '../../../Api/Services/AccountApiService'
import { fetchFileAsBufferFile, getAllUsersData, getBussinesDaysForStaffRole } from '../../../Api/Services/CommonApiService'
import { CompanyDataByUser } from '../../../Api/Services/CompanyApiService'
import { FetchSalesOrderDetails, FetchAllSalesOrder, } from '../../../Api/Services/SalesOrderApiService'
import { FetchAllQuotes } from '../../../Api/Services/QuotesApiService'
import { AddUser } from '../style';
import { setEditCall } from '../../../redux/CrmReduxCalls/EditNavCtrl';
// import { PageHeader } from '../../../components/page-headers/page-headers';
// import { Cards } from '../../../components/cards/frame/cards-frame';
import ComposeMail from '../Email/QSICompose';
import { ExchangeCurrency, convertCurrency, useExcryptedNavigation, useNavigationDecrypted } from '../Filters/FilterConditions';
import { Main, BasicFormWrapper, OrderSummary, VerticalFormStyleWrap } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import Heading from '../../../components/heading/heading';
import AllCancelPopup from '../Popup/AllCancelPopup';
import UpdateConnectionPopup from '../Popup/UpdateConnectionPopup';
import DefaultMessagePopup from '../Popup/DefaultMessagePopup'
import ConfirmationPopup from '../Popup/ConfirmationPopup'
import AddressPopup from '../Popup/AddressPopup'
import { EmailIcon, PdfDownloadIcon, QUSOINIcon, DeleteIcon, SaveIcon, CancelIcon, EditIcon } from '../../../components/Icons/Icons';
import { validateDescriptionField, validateShortText } from '../../../components/utilities/utilities';

const { Option } = Select;

function AddNew({ UrlId, FromPage, setCratePage, GetAll, dataForDeal, ShortCut }) {
    const prevValues = useRef({ UrlId: "", FromPage: "" });
    const { emailactiontype } = useSelector((state) => state.EmailData);
    const InvoiceDeLocalData = useSelector((state) => state.localRedux);
    const Role = InvoiceDeLocalData.role
    const defaultCurrency = InvoiceDeLocalData.currency
    const ProfileData = InvoiceDeLocalData.profile
    const profile = ProfileData
    const dispatch = useDispatch();
    const [pages] = useState("Meeting")
    function extractTimeZoneName(tzString) {
        const parts = tzString.split(" ");
        return parts[1];
    }
    const tzString = profile?.timeZone || "(GMT+0:00) UTC";
    const tz = extractTimeZoneName(tzString);
    const currentrealTime = moment().tz(tz).format("YYYY-MM-DD HH:mm")
    const currentDatess = new Date(currentrealTime);
    const loadingRef = useRef(false);
    const [doubleClick, setDoubleClick] = useState(false)
    const history = useHistory();
    const [form] = Form.useForm();
    const [items, setItems] = useState([])
    const [users, setUsers] = useState([])
    const [deal, setDeal] = useState([])
    const [FILEList, setFileList] = useState([]);
    const [account, setAccount] = useState([])
    const [contact, setContact] = useState([])
    const [edit, setEdit] = useState(false)
    const [allList, setAllList] = useState([])
    const [mailOpen, setMailOpen] = useState(false)
    const [companyData, setCompanyData] = useState()
    const [invoiceId, setInvoiceId] = useState()
    const [displayData, setDisplayData] = useState()
    const [QuotesData, setQuotesData] = useState([])
    const [salesOrder, setSalesOrder] = useState([])
    const [conatactDetails, setConatactDetails] = useState()
    const [InvoiceStatus, setInvoiceStatus] = useState()
    const [paymentStatus, setPaymentStatus] = useState()
    const [currencySettings, setCurrencySetting] = useState()
    const currencySettingsRef = useRef(currencySettings);
    const [DueDate, setDueDate] = useState(null)
    const [InvoiceDate, setInvoiceDate] = useState(null)
    const [billingAddress, setBillingAddress] = useState({})
    const [shipingAddress, setShipingAddress] = useState({})
    const [accountId, setAccountId] = useState(null)
    const [popupOpen, setPopupOpen] = useState(false)
    const [confirmPopup, setConfirmPopup] = useState(false)
    const [dealDiscount, setDealDiscount] = useState()
    const [ProductColumns, setProductColumns] = useState([])
    const [total, setTotal] = useState()
    const [dealType, setDealType] = useState()
    const [grandTotal, setGrandTotal] = useState()
    const [tax, setTax] = useState()
    const [errorData, setErrorData] = useState([])
    const [uiReady, setUiReady] = useState(false)
    const [editField, setEditField] = useState(false)
    const [adjustment, setAdjustment] = useState()
    const [deleteId, setDeleteId] = useState()
    const [popupType, setPopupType] = useState()
    const [popupMessage, setPopupMessage] = useState(false)
    const [popupContent, setPopupContent] = useState()
    const [tableItems, setTableItems] = useState()
    const [shippingss, setShipping] = useState(0)
    const [attachFile, setAttachFile] = useState()
    const [isModalVisible1, setIsModalVisible1] = useState(false)
    const ConvertRate = currencySettings?.exchangeRate;
    const [errors, setErrors] = useState({});
    const [cancelConfirmOpen, setCancelConfirmOpen] = useState(false)
    const Billing = Object.entries(billingAddress)
        .filter(([key]) => key !== 'email' && key !== 'mobile')
        .some(([, value]) => value);
    const Shipping = Object.entries(shipingAddress)
        .filter(([key]) => key !== 'email' && key !== 'mobile')
        .some(([, value]) => value);
    const validateDate = (date, index, fieldName) => {
        const errorKey = `${fieldName}-${index}`;
        if (!date) {
            setErrors(prevErrors => ({
                ...prevErrors,
                [errorKey]: true
            }));
        } else {
            setErrors(prevErrors => {
                const newErrors = { ...prevErrors };
                delete newErrors[errorKey];
                return newErrors;
            });
        }
    };
    const isObject = (obj) => obj && typeof obj === "object";
    const normalizeForComparison = (val1, val2) => {
        // If payload value (val1) is a number, try converting displayData value (val2) to number
        if (typeof val1 === "number") {
            const num2 = Number(val2);
            return [val1, Number.isNaN(num2) ? val2 : num2]; // ✅ replaced isNaN with Number.isNaN
        }

        // If payload value is a numeric string and displayData is number → convert payload to number
        if (typeof val1 === "string" && val1.trim() !== "" && !Number.isNaN(Number(val1)) && typeof val2 === "number") {
            return [Number(val1), val2]; // ✅ also using Number.isNaN here
        }

        // Otherwise, return as-is
        return [val1, val2];
    };
    const PageCancel = () => {
        dispatch(setEditCall(false))
        history.push('/Home/invoices')
    }
    const deepEqual = (obj1, obj2, ignoreKeys = []) => {
        // ✅ CHANGED: added normalization step for non-object values
        if (!isObject(obj1) || !isObject(obj2)) {
            const [val1, val2] = normalizeForComparison(obj1, obj2);
            return val1 === val2;
        }

        // Handle arrays (same as before)
        if (Array.isArray(obj1) && Array.isArray(obj2)) {
            if (obj1.length !== obj2.length) return false;
            return obj1.every((item, i) => deepEqual(item, obj2[i], ignoreKeys));
        }

        // Handle objects (same as before)
        const keys1 = Object.keys(obj1).filter((k) => !ignoreKeys.includes(k));
        const keys2 = Object.keys(obj2).filter((k) => !ignoreKeys.includes(k));

        if (keys1.length !== keys2.length) return false;

        return keys1.every(
            (key) => keys2.includes(key) && deepEqual(obj1[key], obj2[key], ignoreKeys)
        );
    };
    const disabledDate = current => {
        return current && current < moment().startOf('day');
    };
    const { ExcryptedNavigation } = useExcryptedNavigation();
    const ViewDetailPage = (id, entity) => {
        ExcryptedNavigation("Nav", id, entity, history, dispatch, null, null)
    }
    const getWorkingDays = async (id, startDate, endDate) => {
        try {
            const response = await getBussinesDaysForStaffRole(id, startDate, endDate)
            return response;
        }
        catch (error) {
            message.error(error)
        }
    }
    // const getDaysBetween = (startDate, endDate) => {
    //     const start = new Date(startDate);
    //     const end = new Date(endDate);
    //     const timeDifference = end - start;
    //     const daysDifference = timeDifference / (1000 * 60 * 60 * 24);
    //     return daysDifference;
    // };
    const validateCode = (_, value) => {
        const allowedRegex = /^[A-Za-z0-9-]+$/;
        if (!allowedRegex.test(value)) {
            return Promise.reject(
                new Error("Only letters, numbers, and hyphens (-) are allowed")
            );
        }
        if (value.length > 15) {
            return Promise.reject(
                new Error("Account number cannot exceed 15 characters")
            );
        }
        const getList = allList
            .filter(item => item.invoiceId !== invoiceId)
        const existingCodes = getList.map(item => item.invoiceNumber)
        if (existingCodes.includes(value)) {
            return Promise.reject(new Error("This nubmber already exists"));
        }
        return Promise.resolve();
    };
    const generateUniqueCode = (Code, existingData) => {
        let newCode;
        const existingCodes = new Set(existingData.map(item => item.invoiceNumber));
        do {
            const randomNumber = Math.floor(100000 + Math.random() * 900000);
            newCode = `${Code}-${randomNumber}`;
        } while (existingCodes.has(newCode));
        return newCode;
    };
    const getList = async (type) => {
        try {
            const data = await getCompanyInvoice()
            if (type === "Create") {
                const newCode = generateUniqueCode("INV", data);
                form.setFieldsValue({
                    number: newCode,
                })
            }
            setAllList(data)
        }
        catch (error) {
            message.error(error)
        }
    }
    const RequiredDateFormating = (dateString) => {
        if (dateString) {
            const parsedDate = moment(dateString, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
            const formattedDate = parsedDate.format("YYYY-MM-DD");
            return formattedDate;
        }
        return null;
    };
    const formatDateString = (dateString, format) => {
        return moment(dateString, "YYYY-MM-DD").format(format);
    };
    const DueDateChange = (date, dateString) => {
        const formattedDate = RequiredDateFormating(dateString)
        setDueDate(formattedDate);
    };
    const invoiceDateChange = (date, dateString) => {
        const formattedDate = RequiredDateFormating(dateString)
        setInvoiceDate(formattedDate);
    };
    const onnavigate = () => {
        dispatch(setEditCall(false))
        history.push("/Home/email-config")
    }
    function totalCalculation() {
        const latestCurrencySettings = currencySettingsRef.current;
        const CurencyDecimalPlace = latestCurrencySettings?.decimalOfCurrency;
        let subtotal = 0;
        let discountedTotal = 0;
        let taxTotal = 0;
        let grandTotal = 0;
        const isValidNumber = (val) => val !== "0" && val !== 0 && val !== "" && val !== null && val !== undefined;
        if (items?.length > 0) {
            for (let i = 0; i < items?.length; i += 1) {
                if (items[i].total) {
                    subtotal += Number(items[i].total);
                }
            }
        }
        if (isValidNumber(dealDiscount)) {
            discountedTotal = subtotal * (1 - Number(dealDiscount) / 100);
        } else {
            discountedTotal = subtotal;
        }
        if (isValidNumber(tax)) {
            taxTotal = discountedTotal * (1 + Number(tax) / 100);
        } else {
            taxTotal = discountedTotal;
        }

        grandTotal = taxTotal;

        if (isValidNumber(adjustment)) {
            grandTotal -= Number(adjustment);
        }

        if (isValidNumber(shippingss)) {
            grandTotal += Number(shippingss);
        }
        setTotal(subtotal?.toFixed(CurencyDecimalPlace));
        setGrandTotal(grandTotal?.toFixed(CurencyDecimalPlace));
    }
    const removeItem = (index, data) => {
        const updatedFormData = [...data];
        updatedFormData.splice(index, 1);
        setItems(updatedFormData);
    }
    const handleTableItem = async (index, fieldName, value, data, type, id) => {
        const latestCurrencySettings = currencySettingsRef.current;
        const CurencyDecimalPlace = latestCurrencySettings?.decimalOfCurrency;
        const updatedFormData = [...data];
        if (fieldName === "startDate" || fieldName === "endDate") {
            const date = RequiredDateFormating(value)
            updatedFormData[index] = {
                ...updatedFormData[index],
                [fieldName]: date,
            };
        }
        else {
            updatedFormData[index] = {
                ...updatedFormData[index],
                [fieldName]: value,
            };
        }
        const Cost = parseFloat(updatedFormData[index].value || 0);
        if (type === "StaffAug") {
            let totalBusinessDays = 0;
            if (id && updatedFormData[index].startDate && updatedFormData[index].endDate) {
                totalBusinessDays = await getWorkingDays(id, updatedFormData[index].startDate, updatedFormData[index].endDate);
            } if (Cost > 0 && totalBusinessDays > 0) {
                const totalValue = Cost * totalBusinessDays
                updatedFormData[index].total = totalValue?.toFixed(CurencyDecimalPlace)
            }
            else {
                updatedFormData[index].total = 0
            }
        }
        if (type === "Product") {
            const numberOfUnits = parseFloat(updatedFormData[index].qty || 0);
            const licenseDuration = parseFloat(updatedFormData[index].duration || 0);
            if (Cost > 0 && numberOfUnits > 0 && licenseDuration > 0) {
                const totalValue = Cost * numberOfUnits * licenseDuration
                updatedFormData[index].total = totalValue?.toFixed(CurencyDecimalPlace)
            } else {
                updatedFormData[index].total = 0
            }
        }
        if (type === "Others" || type === "RFP" || type === "Service") {
            updatedFormData[index].total = Cost
        }
        setItems(updatedFormData);
    };
    async function getContactDe(value) {
        if (value.conatctId) {
            try {
                const responseData = await FetchContactDetails(value.conatctId)
                const contactDetailsDataQ = responseData.data
                setConatactDetails(contactDetailsDataQ)
            } catch (error) {
                setConatactDetails()
                message.error(error)
            }
        }
    }
    const setData = async (value) => {
        if (value) {
            const latestCurrencySettings = currencySettingsRef.current;
            const ConvertRates = latestCurrencySettings?.exchangeRate;
            const CurencyDecimalPlace = currencySettings?.decimalOfCurrency;
            setInvoiceId(value.invoiceId)
            setPaymentStatus(value.paymentStatus)
            const salesCommision = value.salesCommision
                ? await ExchangeCurrency(Number(value.salesCommision), ConvertRates)
                : value.salesCommision;
            const exciseDuty = value.exciseDuty
                ? await ExchangeCurrency(Number(value.exciseDuty), ConvertRates)
                : value.exciseDuty;
            const paidAmountDuty = value.paidAmount
                ? await ExchangeCurrency(Number(value.paidAmount), ConvertRates)
                : value.paidAmount;
            const balanceAmountDuty = value.balanceAmount
                ? await ExchangeCurrency(Number(value.balanceAmount), ConvertRates)
                : value.balanceAmount;
            form.setFieldsValue({
                balanceAmount: balanceAmountDuty && balanceAmountDuty !== "" ? Number(balanceAmountDuty?.toFixed(CurencyDecimalPlace)) : undefined,
                paidAmount: paidAmountDuty && paidAmountDuty !== "" ? Number(paidAmountDuty?.toFixed(CurencyDecimalPlace)) : undefined,
                paymentStatus: value.paymentStatus,
                subject: value.invoiceName,
                number: value.invoiceNumber,
                InOwner: value.invoiceOwner,
                sonumber: value.salesOrderId,
                prnumber: value.purchaseOrderNumber,
                qnumber: value.quoteId,
                status: value.invoiceStatus,
                deal: value.dealId,
                account: value.accountId,
                exciseduty: exciseDuty && exciseDuty !== "" ? Number(exciseDuty?.toFixed(CurencyDecimalPlace)) : undefined,
                salescommision: salesCommision && salesCommision !== "" ? Number(salesCommision?.toFixed(CurencyDecimalPlace)) : undefined,
                contact: value.conatctId,
                description: value.description,
                termsandCondition: value.termsAndCondition,
                invoicedate: value.invoiceDate === "" || value.invoiceDate === null ? null :
                    moment(formatDateString(value.invoiceDate, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"), profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"),
                date: value.dueDate === "" || value.dueDate === null ? null :
                    moment(formatDateString(value.dueDate, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"), profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"),
            })
            setInvoiceStatus(value.invoiceStatus)
            setAccountId(value.accountId)
            setBillingAddress(value.billingAddress)
            setShipingAddress(value.shippingAddress)
            setDueDate(value.dueDate)
            setInvoiceDate(value.invoiceDate)
            const subtotal = value.invoiceItem?.subtotalamount
                ? await ExchangeCurrency(Number(value.invoiceItem?.subtotalamount), ConvertRates)
                : value.invoiceItem.subtotalamount;
            const total = value.invoiceItem?.grandTotalamount
                ? await ExchangeCurrency(Number(value.invoiceItem?.grandTotalamount), ConvertRates)
                : value.invoiceItem.grandTotalamount;
            const adjustent = value.invoiceItem?.adjustmentAmount
                ? await ExchangeCurrency(Number(value.invoiceItem?.adjustmentAmount), ConvertRates)
                : value.invoiceItem?.adjustmentAmount;
            const shipppingdatra = value.invoiceItem?.shippingamount
                ? await ExchangeCurrency(Number(value.invoiceItem?.shippingamount), ConvertRates)
                : value.invoiceItem?.shippingamount;
            setDealDiscount(value.invoiceItem?.discountamount)
            setTotal(subtotal)
            setGrandTotal(total)
            setTax(value.invoiceItem?.taxAmount)
            setDealType(value.invoiceItem?.dealData)
            setAdjustment(Number(adjustent?.toFixed(CurencyDecimalPlace)) || 0)
            setShipping(Number(shipppingdatra?.toFixed(CurencyDecimalPlace)) || 0)
            const convertedRoleData = await Promise.all(
                value.invoiceItem?.item.map(async (role) => {
                    const convertedRate = await (role.value !== undefined && role.value !== null && role.value !== ""
                        ? ExchangeCurrency(Number(role.value), ConvertRates)
                        : role.value);
                    const convertedTotalValue = await (role.total !== undefined && role.total !== null && role.total !== ""
                        ? ExchangeCurrency(Number(role.total), ConvertRates)
                        : role.total);
                    return {
                        ...role,
                        value: Number(convertedRate?.toFixed(CurencyDecimalPlace)),
                        total: Number(convertedTotalValue?.toFixed(CurencyDecimalPlace)),
                    };
                })
            );
            setItems(convertedRoleData)
            // const QuotesItemArrayColumn = await QuotesItemListColumn(value.invoiceItem?.dealData, profile, disabledDate, latestCurrencySettings, "Invoice", items, removeItem, handleTableItem);
            // setProductColumns(QuotesItemArrayColumn)
            setTableItems(value.invoiceItem?.dealData)
            setFileList(value.uploadFile || [])
            const updateData = {
                ...value,
                exciseDuty: exciseDuty && exciseDuty !== "" ? Number(exciseDuty?.toFixed(CurencyDecimalPlace)) : undefined,
                salesCommision: salesCommision && salesCommision !== "" ? Number(salesCommision?.toFixed(CurencyDecimalPlace)) : undefined,
                paidAmount: paidAmountDuty && paidAmountDuty !== "" ? Number(paidAmountDuty?.toFixed(CurencyDecimalPlace)) : undefined,
                balanceAmount: balanceAmountDuty && balanceAmountDuty !== "" ? Number(balanceAmountDuty?.toFixed(CurencyDecimalPlace)) : undefined,
            }
            setDisplayData(updateData)
            getContactDe(value)
        }
    }
    async function getAccoutList(value) {
        if (value.accountId) {
            try {
                const contactArray = await getDealDatabyAccount(value.accountId, value.dealId)
                setDeal(contactArray)
            } catch (error) {
                setDeal([])
                message.error(error)
            }
        } else {
            setDeal([])
        }
    }
    async function getDealList(value) {
        if (value.dealId) {
            try {
                const contactArray = await getContactDatabyAccount(value.dealId, value.conatctId)
                setContact(contactArray)
            } catch (error) {
                setContact([])
                message.error(error)
            }
        } else {
            setContact([])
        }
    }
    async function getData(id) {
        try {
            const response = await findOneByInvoice(id)
            if (!response.allow) throw new Error();
            setData(response.data);
        } catch (error) {
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: 'error',
                content: `This record is no longer available. It may have been deleted or moved`,
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: 'error',
                        content: `This record is no longer available. It may have been deleted or moved`,
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    const CloseDrawer = () => {
        setCancelConfirmOpen(false)
        setPaymentStatus()
        form.setFieldsValue({
            balanceAmount: null,
            paidAmount: null,
            paymentStatus: null,
            subject: null,
            number: null,
            InOwner: null,
            sonumber: null,
            prnumber: null,
            qnumber: null,
            status: null,
            deal: null,
            account: null,
            exciseduty: null,
            salescommision: null,
            contact: null,
            description: null,
            termsandCondition: null,
            invoicedate: null,
            date: null
        })
        setInvoiceStatus()
        setAccountId()
        setBillingAddress({})
        setShipingAddress({})
        setDueDate()
        setInvoiceDate()
        setShipping(0)
        setDealDiscount()
        setTotal()
        setGrandTotal()
        setTax()
        setDealType()
        setAdjustment()
        setDeal([])
        setContact([])
        setItems([])
        setTableItems()
        setConatactDetails()
        setFileList([])
        if (FromPage !== "EntityUpdate" && FromPage !== "FromSalesOR" && ShortCut !== "Shortcut") {
            GetAll();
        }
        if (FromPage !== "EntityUpdate") {
            setCratePage();
        }
        setEdit(false);
        setEditField(false);
        dispatch(setEditCall(false))
    }
    const CloseDrawerNew = () => {
        setCancelConfirmOpen(false)
        setEdit(false);
        setEditField(false);
        dispatch(setEditCall(false))
    }
    async function getData1(id, hideMessage, updateResponse) {
        try {
            const response = await findOneByInvoice(id)
            hideMessage()
            message.success(
                <span>
                    Invoice <strong>{updateResponse?.data?.[0]?.entityName}</strong> has been updated successfully
                </span>
            );
            if (!response.allow) throw new Error();
            setData(response.data);
            loadingRef.current = false;
            setDoubleClick(false)
            CloseDrawerNew()
        } catch (error) {
            hideMessage()
            loadingRef.current = false;
            setDoubleClick(false)
            message.success(
                <span>
                    Invoice <strong>{updateResponse?.data?.[0]?.entityName}</strong> has been updated successfully
                </span>
            );
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: 'error',
                content: `This record is no longer available. It may have been deleted or moved`,
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: 'error',
                        content: `This record is no longer available. It may have been deleted or moved`,
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    const { NavigationDecrypted } = useNavigationDecrypted()
    async function getEntityAvalibitlity() {
        let dataFound = true;
        try {
            const response = await NavigationDecrypted(UrlId[1])
            if (response) {
                setInvoiceId(response)
                dataFound = true;
                getData(response)
            }
            else {
                dataFound = false;
            }
        } catch (error) {
            dataFound = false;
        }
        if (!dataFound) {
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: 'error',
                content: `This record is no longer available. It may have been deleted or moved`,
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: 'error',
                        content: `This record is no longer available. It may have been deleted or moved`,
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    // const fetchFileAsBuffer = async (url) => {
    //     try {
    //         const fileName = url.split('/').pop();
    //         const response = await fetchFileAsBufferFile(fileName)
    //         if (response && response.type === "Buffer" && Array.isArray(response.data)) {
    //             const uint8Array = new Uint8Array(response.data);
    //             const binaryString = uint8Array.reduce((acc, byte) => acc + String.fromCharCode(byte), "");
    //             const base64String = btoa(binaryString);
    //             return `data:image/png;base64,${base64String}`;
    //         }
    //         return null;
    //     } catch (error) {
    //         message.error(error)
    //     }
    // };
    const fetchFileAsBuffer = async (url) => {
        try {
            const fileName = url.split('/').pop();
            const response = await fetchFileAsBufferFile(fileName); // your API call
            if (response && response.type === "Buffer" && Array.isArray(response.data)) {
                const uint8Array = new Uint8Array(response.data);
                // Create a Blob from the Uint8Array
                const blob = new Blob([uint8Array]);
                // Create a URL for the Blob (fastest, no base64 conversion needed)
                const objectUrl = URL.createObjectURL(blob);
                return objectUrl;
            }
            return null;
        } catch (error) {
            message.error(error)
            return null;
        }
    };
    async function getCompanyDetails() {
        try {
            const data = await CompanyDataByUser()
            const base64Image = await fetchFileAsBuffer(data.accountLogo);
            const changedData = { ...data, accountLogo: base64Image }
            setCompanyData(changedData);
        } catch (error) {
            message.error(error);
        }
    }
    async function getSalesOrderData(value) {
        let hideMessage;
        const latestCurrencySettings = currencySettingsRef.current;
        const ConvertRates = latestCurrencySettings?.exchangeRate;
        const CurencyDecimalPlace = currencySettings?.decimalOfCurrency;
        try {
            hideMessage = message.loading("Sync with tenancy agreement...", 0);
            const response = await FetchSalesOrderDetails(value?.SalesORId);
            const salesCommision = response.data.salesCommision
                ? await ExchangeCurrency(Number(response.data.salesCommision), ConvertRates)
                : response.data.salesCommision;
            const exciseDuty = response.data.exciseDuty
                ? await ExchangeCurrency(Number(response.data.exciseDuty), ConvertRates)
                : response.data.exciseDuty;
            form.setFieldsValue({
                sonumber: response.data.salesOrderId,
                prnumber: response.data.purchaseOrderNumber,
                qnumber: response.data.quoteId,
                deal: response.data.dealId,
                account: response.data.accountId,
                exciseduty: exciseDuty && exciseDuty !== "" ? Number(exciseDuty?.toFixed(CurencyDecimalPlace)) : undefined,
                salescommision: salesCommision && salesCommision !== "" ? Number(salesCommision?.toFixed(CurencyDecimalPlace)) : undefined,
                contact: response.data.conatctId,
                description: response.data.description,
                termsandCondition: response.data.termsAndCondition,
                // date: response.data.dueDate === "" || response.data.dueDate === null ? null :
                //     moment(formatDateString(response.data.dueDate, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"), profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
            })
            // setDueDate(response.data.dueDate)
            setAccountId(response.data.accountId)
            setBillingAddress(response.data.billingAddress)
            setShipingAddress(response.data.shippingAddress)
            const subtotal = response.data.salesOrderItem?.subtotalamount
                ? await ExchangeCurrency(Number(response.data.salesOrderItem?.subtotalamount), ConvertRates)
                : response.data.salesOrderItem.subtotalamount;
            const total = response.data.salesOrderItem?.grandTotalamount
                ? await ExchangeCurrency(Number(response.data.salesOrderItem?.grandTotalamount), ConvertRates)
                : response.data.salesOrderItem.grandTotalamount;
            const adjustent = response.data.salesOrderItem?.adjustmentAmount
                ? await ExchangeCurrency(Number(response.data.salesOrderItem?.adjustmentAmount), ConvertRates)
                : response.data.salesOrderItem?.adjustmentAmount;
            const shipppingdatra = response.data.salesOrderItem?.shippingamount
                ? await ExchangeCurrency(Number(response.data.salesOrderItem?.shippingamount), ConvertRates)
                : response.data.salesOrderItem?.shippingamount;
            setDealDiscount(response.data.salesOrderItem?.discountamount)
            setTotal(subtotal)
            setGrandTotal(total)
            setTax(response.data.salesOrderItem?.taxAmount)
            setDealType(response.data.salesOrderItem?.dealData)
            setAdjustment(Number(adjustent?.toFixed(CurencyDecimalPlace)) || 0)
            setShipping(Number(shipppingdatra?.toFixed(CurencyDecimalPlace)) || 0)
            const dealArray = response.data.accountId ? await getDealDatabyAccount(response.data.accountId, response.data.dealId) : [];
            setDeal(dealArray)
            const contactArray = response.data.dealId ? await getContactDatabyAccount(response.data.dealId, response.data.conatctId) : [];
            setContact(contactArray)
            const convertedRoleData = await Promise.all(
                response.data.salesOrderItem?.item.map(async (role) => {
                    const convertedRate = await (role.value !== undefined && role.value !== null && role.value !== ""
                        ? ExchangeCurrency(Number(role.value), ConvertRates)
                        : role.value);
                    const convertedTotalValue = await (role.total !== undefined && role.total !== null && role.total !== ""
                        ? ExchangeCurrency(Number(role.total), ConvertRates)
                        : role.total);
                    return {
                        ...role,
                        value: Number(convertedRate?.toFixed(CurencyDecimalPlace)),
                        total: Number(convertedTotalValue?.toFixed(CurencyDecimalPlace)),
                    };
                })
            );
            setItems(convertedRoleData)
            // const QuotesItemArrayColumn = await QuotesItemListColumn(response.data.salesOrderItem?.dealData, profile, disabledDate, latestCurrencySettings, "Invoice", items, removeItem, handleTableItem);
            // setProductColumns(QuotesItemArrayColumn)
            setTableItems(response.data.salesOrderItem?.dealData)
            const responseData = await FetchContactDetails(response.data.conatctId)
            const contactDetailsData = responseData.data
            setConatactDetails(contactDetailsData)
            hideMessage();
            message.success("Invoice updated with current tenancy agreement details");
        } catch (error) {
            message.error("Failed to sync with current tenancy agreement");
            hideMessage();
        }
    }
    async function UserDetailsApi() {
        try {
            const data = await getAllUsersData()
            const options = data.filter(item => item.department === "Sales").map((option, i) => (
                <Option value={option.userId} key={i} label={(
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className='Div_flex2'>
                            <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                    < img src={option.profilePic} alt="profile" />
                                    :
                                    <span className="image_icon UserIcon">
                                        {option.firstName.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                            </div>
                        </div>
                    </div>
                    // <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    //     {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                    //         < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                    //         :
                    //         <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                    //             {option.firstName.slice(0, 1).toUpperCase()}
                    //         </span>
                    //     }
                    //     <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                    // </div>
                )}>
                    <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                        <div>
                            {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.firstName.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                            <p style={{ margin: 0 }}>{option.username}</p>
                        </div>
                    </div>
                </Option>));
            setUsers(options)
        } catch (error) { message.error(error) }
    }
    async function GetSalesOrders() {
        try {
            const response = await FetchAllSalesOrder()
            setSalesOrder(response)
        } catch (error) { message.error(error) }
    }
    async function getAllQuotes() {
        try {
            const response = await FetchAllQuotes()
            setQuotesData(response)
        } catch (error) { message.error(error) }
    }
    async function AccountApi() {
        try {
            const data = await FetchAllAccount()
            let accountInfo = data;
            if (displayData?.accountId) {
                const isAlreadyIncluded = data?.some(contact => contact.account_id === displayData?.accountId);
                if (!isAlreadyIncluded) {
                    accountInfo = [...accountInfo, { account_name: displayData?.accountName, account_number: displayData?.accountNumber, account_id: displayData?.accountId, account_type_name: "Customer" }];
                }
            }
            const options = accountInfo.filter((item) => item.account_type_name === "Customer").map((option, i) => (
                <Option value={option.account_id} key={i} label={(
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className='Div_flex2'>
                            <div className='share_image' title={`${option.account_name} (${option.account_number})`} style={{ cursor: "default" }}>
                                {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                    < img src={option.account_profile} alt="profile" />
                                    :
                                    <span className="image_icon AccountIcon">
                                        {option.account_name.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <span className='div-ellipsis'>{option.account_name}</span>
                            </div>
                        </div>
                    </div>)}>
                    <div className='UserList-dropdown' title={`${option.account_name} (${option.account_number})`}>
                        <div>
                            {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                < img src={option.account_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag AccountIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.account_name.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.account_name}</p>
                            <p style={{ margin: 0 }}>{option.account_number}</p>
                        </div>
                    </div>
                </Option>));
            setAccount(options)
        } catch (error) { message.error(error) }
    }
    async function onChangeContact(value) {
        form.setFieldsValue({ contact: value || null })
        try {
            if (value) {
                const responseData = await FetchContactDetails(value);
                const response = responseData
                setBillingAddress({
                    name: billingAddress?.name,
                    country: billingAddress?.country,
                    city: billingAddress?.city,
                    state: billingAddress?.state,
                    street: billingAddress?.street,
                    zipcode: billingAddress?.zipcode,
                    email: response?.data?.email,
                    mobile: response?.data?.mobile
                })
                setShipingAddress({
                    name: shipingAddress?.name,
                    country: shipingAddress?.country,
                    city: shipingAddress?.city,
                    state: shipingAddress?.state,
                    street: shipingAddress?.street,
                    zipcode: shipingAddress?.zipcode,
                    email: response?.data?.email,
                    mobile: response?.data?.mobile
                })
            }
            else {
                setBillingAddress({
                    name: billingAddress?.name,
                    country: billingAddress?.country,
                    city: billingAddress?.city,
                    state: billingAddress?.state,
                    street: billingAddress?.street,
                    zipcode: billingAddress?.zipcode,
                    email: undefined,
                    mobile: undefined
                })
                setShipingAddress({
                    name: shipingAddress?.name,
                    country: shipingAddress?.country,
                    city: shipingAddress?.city,
                    state: shipingAddress?.state,
                    street: shipingAddress?.street,
                    zipcode: shipingAddress?.zipcode,
                    email: undefined,
                    mobile: undefined
                })
            }
        } catch (error) {
            message.error(error)
        }
    }
    const addressPopup = (type, content) => {
        setPopupOpen(true)
        setPopupType(type)
        setPopupContent(content)
    }
    const scroolup = () => {
        const currentPosition = window.scrollY;
        if (currentPosition > 0) {
            const scrollStep = Math.max(1, Math.ceil(currentPosition / 20));
            window.scrollTo(0, currentPosition - scrollStep);
            requestAnimationFrame(scroolup);
        }
    }
    const OnClickofDelete = (value) => {
        setConfirmPopup(true)
        setDeleteId(value)
    }
    async function deleteMenu(id) {
        try {
            const Response = await deleteInvoice(id)
            if (Response.status === 200) {
                setConfirmPopup(false)
                message.success("Invoice deleted")
                dispatch(setEditCall(false));
                history.push('/Home/invoices')
            }
        } catch (error) { message.error(error) }
    }
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
        scroolup()
    }
    const fetchAll = async () => {
        await Promise.allSettled([
            getAccoutList(displayData),
            getDealList(displayData),
            getAllQuotes(),
            GetSalesOrders(),
            UserDetailsApi(),
            AccountApi(),
        ])
        setUiReady(true)
    };
    useEffect(() => {
        if (FromPage) {
            if (defaultCurrency) {
                setCurrencySetting(defaultCurrency);
            }
            scroolup()
        }
    }, [FromPage])
    useEffect(() => {
        if (FromPage && editField && displayData) {
            fetchAll()
        }
    }, [FromPage, editField, displayData])
    useEffect(() => {
        currencySettingsRef.current = currencySettings;
    }, [currencySettings]);
    useEffect(() => {
        if (currencySettings) {
            const currentUrlId = JSON.stringify(UrlId); // <-- serialize for comparison
            const currentFromPage = FromPage;
            if (
                prevValues.current.UrlId === currentUrlId &&
                prevValues.current.FromPage === currentFromPage
            ) {
                return;
            }
            prevValues.current = {
                UrlId: currentUrlId,
                FromPage: currentFromPage,
            };
            if (FromPage) {
                if (FromPage === "EntityUpdate") {
                    if (currencySettings) {
                        getEntityAvalibitlity()
                        getCompanyDetails()
                        getList("Update")
                    }
                } else {
                    if (FromPage === "FromSalesOR") {
                        if (currencySettings) {
                            getSalesOrderData(dataForDeal)
                            form.setFieldsValue({
                                status: "Created",
                            })
                        }
                    } else {
                        form.setFieldsValue({
                            balanceAmount: undefined,
                            paidAmount: undefined,
                            paymentStatus: undefined,
                            subject: undefined,
                            number: undefined,
                            InOwner: undefined,
                            sonumber: undefined,
                            prnumber: undefined,
                            qnumber: undefined,
                            status: "Created",
                            deal: undefined,
                            account: undefined,
                            exciseduty: undefined,
                            salescommision: undefined,
                            contact: undefined,
                            description: undefined,
                            termsandCondition: undefined,
                            invoicedate: undefined,
                            date: undefined
                        })
                    }
                    const getUserDetail = async () => {
                        if (UrlId === undefined || UrlId === null) {
                            if (profile.department === "Sales") {
                                form.setFieldsValue({
                                    InOwner: profile.userId
                                });
                            }
                        }
                    }
                    form.setFieldsValue({
                        invoicedate: moment(currentDatess.toLocaleDateString('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit' }))
                    });
                    getList("Create")
                    setInvoiceDate(currentDatess.toLocaleDateString('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit' }))
                    getUserDetail()
                    setEdit(true)
                    setDisplayData("Create")
                    setInvoiceId()
                    setEditField(true)
                }
            }
        }
    }, [UrlId, currencySettings, FromPage]);
    useEffect(() => {
        if (FromPage) {
            totalCalculation()
        }
    }, [items, dealDiscount, tax, adjustment, shippingss, FromPage])
    useEffect(() => {
        if (FromPage) {
            const TableItemFucntion = async () => {
                const latestCurrencySettings = currencySettingsRef.current;
                const QuotesItemArrayColumn = await QuotesItemListColumn(tableItems, profile, disabledDate, latestCurrencySettings, "Invoice", items, removeItem, handleTableItem, errors, validateDate, edit);
                setProductColumns(QuotesItemArrayColumn)
            }
            if (tableItems) {
                TableItemFucntion()
            }
        }
    }, [items, tableItems, currencySettings, FromPage])
    const updateStatus1 = async (id) => {
        let hideMessage;
        try {
            hideMessage = message.loading("Updating status...", 0);
            const payload = {
                invoiceStatus: "Delivered",
            }
            const response = await updateInvoice(payload, id)
            if (response.status === 200) {
                dispatch(setEditCall(false))
                getData(invoiceId)
                hideMessage();
                scroolup()
            }
        }
        catch (error) {
            hideMessage();
            message.error(error);
        }
    }
    const updateStatus = (values) => {
        if (displayData?.invoiceStatus !== "Delivered") {
            const modal = Modal.confirm({
                title: (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                        <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} />
                        <span> Change Status?</span>
                    </div>
                ),
                icon: null,
                content: (
                    <p>Would you like to update the status of this invoice to Delivered?</p>
                ),
                centered: true,
                className: "customice-confirm-modal",
                okText: "Yes",
                cancelText: "No",
                okButtonProps: {
                    className: "button_colorsModal"
                },
                cancelButtonProps: {
                    className: "gray-buttonModal"
                },
                okCancel: true,
                onOk() {
                    updateStatus1(values)
                },
                onCancel() {
                    modal.destroy();
                },
            });
        }
    };
    const handledownloadPdf = async () => {
        const blob = await pdf(
            <QuotationPdf data={displayData}
                companyData={companyData} tableItem={items}
                tableColum={ProductColumns.slice(0, -1)} currencySettings={currencySettings}
                Calculation={{ total, dealDiscount, tax, adjustment, shippingss, grandTotal }}
            />
        ).toBlob();
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `${displayData?.invoiceNumber}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const CreateMail = async () => {
        if (emailactiontype) {
            setPopupMessage(true)
        }
        else {
            const blob = await pdf(
                <QuotationPdf data={displayData}
                    companyData={companyData} tableItem={items}
                    tableColum={ProductColumns.slice(0, -1)} currencySettings={currencySettings}
                    Calculation={{ total, dealDiscount, tax, adjustment, shippingss, grandTotal }}
                />
            ).toBlob();
            const arrayBuffer = await blob.arrayBuffer();
            const buffer = {
                filename: `${displayData?.invoiceNumber}.pdf`,
                contentType: "application/pdf",
                size: blob.size,
                contentDisposition: "attachment",
                content: {
                    type: "Buffer",
                    data: Array.from(new Uint8Array(arrayBuffer)),
                },
            };
            setAttachFile(buffer)
            setMailOpen(true)
        }
    }
    const closeMailComposr = () => {
        setMailOpen(false);
    };
    // const content = (
    //     <div style={{
    //         width: "100%",
    //         height: "100%",
    //     }}>
    //         <span role="button" className="text_icon moreLinks"
    //             tabIndex={0}
    //             onClick={edit ? () => { getSalesOrderData(displayData?.salesOrderId); setItems([]) } : undefined}
    //             onKeyDown={(event) => {
    //                 if (event.key === 'Enter' || event.key === ' ') {
    //                     getSalesOrderData(displayData?.salesOrderId);
    //                     setItems([])
    //                 }
    //             }}>
    //             <QUSOINIcon height={16} width={16} marginRight={5} /> Sync with Tenancy Agreement
    //         </span>
    //     </div >
    // );
    const SubjectData = `${companyData?.companyName} – Invoice for ${displayData?.invoiceName}`;
    // const MailContent = `<div> </div>
    // <div contenteditable="false" style="margin: 20px 0px 0px"> 
    const MailContent = `<div> </div>
    <div style="margin: 20px 0px 0px">
    <div>Dear ${displayData?.contactFirstName},</div>
    <div>&nbsp;</div>
    <div dir="auto">Thank you for your business with ${companyData?.companyName}. Please find attached the invoice for your reference.</div>
    <div>&nbsp;</div>
    <div>Invoice Details:</div>
    <div>&bull; Invoice Number: ${displayData?.invoiceNumber}</div>
    <div>&bull; Invoice Date: ${displayData?.invoiceDate}</div>
    <div>&bull; Due Date: ${displayData?.dueDate}</div>
    <div>&bull; Total Amount: ${currencySettings?.symbol} ${Number(grandTotal)?.toLocaleString()}</div>
    <div>&nbsp;</div>
    <div>If you have any questions regarding this invoice, please feel free to contact us.</div>
    <div>&nbsp;</div>
     <div id = "signature-block-unique" contenteditable = "true" style = "margin-top: 20px;" >
            ${profile?.profileSignature || "<div>Add signature</div>"}
         </div >
    <div>&nbsp;</div>
    </div>`;
    const handlePaymentchange = (value) => {
        setPaymentStatus(value)
        if (value === "Fully Paid") {
            form.setFieldsValue({
                paidAmount: grandTotal,
                balanceAmount: 0,
            });
        }
        else {
            form.setFieldsValue({
                paidAmount: 0,
                balanceAmount: 0,
            });
        }
    }
    const handlePaidChange = (value) => {
        const numericValue = Number(value) || 0;
        const balanceAmount = parseFloat((grandTotal - numericValue)?.toFixed(currencySettings?.decimalOfCurrency));
        form.setFieldsValue({
            balanceAmount: balanceAmount >= 0 ? balanceAmount : 0,
        });
    };
    useEffect(() => {
        if (FromPage) {
            if (paymentStatus === "Fully Paid") {
                form.setFieldsValue({
                    paidAmount: grandTotal,
                    balanceAmount: 0,
                });
            }
            else {
                form.setFieldsValue({
                    paidAmount: 0,
                    balanceAmount: 0,
                });
            }
        }
    }, [grandTotal, FromPage])
    const handleEditChange = () => {
        setEditField(true)
        setEdit(true)
        dispatch(setEditCall(true))
    }
    const ButtonActions = [
        {
            Actions: <div className='Hover-Refresh2 back-hover1 able-style'
                role="button"
                tabIndex={0} title='Send Email'
                onClick={() => CreateMail()}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        CreateMail()
                    }
                }}
                aria-label='mail'
            > <EmailIcon height={20} width={20} /></div>
        },
        {
            Actions: <div className='Hover-Refresh2 back-hover1 able-style'
                role="button"
                tabIndex={0} title='Download PDF'
                onClick={() => handledownloadPdf()}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        handledownloadPdf()
                    }
                }}
                aria-label='pdf'
            > <PdfDownloadIcon height={20} width={20} /></div>
        }
    ]
    const moreAction = "No"
    const MoreAction = () => (<></>)
    const LeadInfos = {
        profile: undefined,
        Classname: " ",
        letterIcon: displayData?.invoiceName,
        name: displayData?.invoiceName,
        subName: `${displayData?.invoiceNumber}`,
        mainAction: undefined,
    }

    const getDetailsDatas = useCallback(() => getData(invoiceId), [invoiceId]);
    const LeadDetails = (<QuotesFields Billing={Billing} billingAddress={billingAddress} Shipping={Shipping} shipingAddress={shipingAddress} displayData={displayData} currencySettings={currencySettings} getDetailsData={getDetailsDatas} />);
    const RelatedDetails = (
        <div style={{ height: "100vh" }}>
            {companyData ? (
                <PDFViewer width="100%" height="100%">
                    <QuotationPdf data={displayData} companyData={companyData} tableItem={items} tableColum={ProductColumns.slice(0, -1)} currencySettings={currencySettings} Calculation={{ total, dealDiscount, tax, adjustment, shippingss, grandTotal }} />
                </PDFViewer>
            ) : (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                    <Spin size="large" tip="Loading PDF..." />
                </div>
            )}
        </div>
    )
    const RightRelatedDetails = (<QuotesRight displayData={displayData} profile={profile} ViewDetailPage={ViewDetailPage} Role={Role} currencySettings={currencySettings} />)
    const EditOpenForDrawer = () => {
        setEdit(true)
        dispatch(setEditCall(true))
    }
    const CloseDrawer2 = () => {
        scroolup();
        getData(invoiceId)
        setEditField(false)
        setEdit(false);
        dispatch(setEditCall(false))
    }
    const PageCancel1 = () => {
        if (FromPage === "EntityUpdate") {
            CloseDrawer2()
        }
        else {
            setCancelConfirmOpen(true)
        }
    }
    async function onSubmitApiCall(payload) {
        let hideMessage;
        try {
            hideMessage = message.loading("Loading...", 0);
            if (FromPage === "EntityUpdate") {
                const response = await updateInvoice(payload, invoiceId)
                if (response.status === 200) {
                    if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                        setErrorData(response.data);
                        setIsModalVisible1(true);
                        loadingRef.current = false;
                        setDoubleClick(false)
                        hideMessage();
                    }
                    else {
                        const ownerChanged = displayData.invoiceOwner !== payload.invoiceOwner;
                        if (ownerChanged) {
                            hideMessage()
                            message.success(
                                <span>
                                    Invoice <strong>{response?.data?.[0]?.entityName}</strong> has been updated successfully
                                </span>
                            );
                            dispatch(setEditCall(false));
                            history.push('/Home/invoices')
                        }
                        else {
                            getData1(invoiceId, hideMessage, response)
                            scroolup()
                        }
                    }
                }
            }
            else {
                const response = await createInvoice(payload)
                if (response.status === 201) {
                    hideMessage();
                    if (ShortCut === "Shortcut") {
                        dispatch(setEditCall(false))
                        history.push('/Home/invoices')
                    }
                    message.success("Invoice created")
                    if (FromPage === "FromSalesOR") {
                        dispatch(setEditCall(false))
                        history.push('/Home/invoices')
                    }
                    loadingRef.current = false;
                    setDoubleClick(false)
                    CloseDrawer()
                }
            }
        }
        catch (error) {
            hideMessage();
            loadingRef.current = false;
            setDoubleClick(false)
            message.error(error);
        }
    }
    const showConfirmForAccount = (values) => {
        const modal = Modal.confirm({
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                    <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} />
                    <span> Delivered State</span>
                </div>
            ),
            icon: null,
            className: "customice-confirm-modal",
            content: (
                <p>This invoice is marked as <strong>Delivered</strong>. Any changes will require sending a revised version to the customer. Do you wish to continue with the changes?</p>
            ),
            centered: true,
            okText: "No",
            cancelText: "Yes",
            okButtonProps: {
                className: "gray-buttonModal"
            },
            cancelButtonProps: {
                className: "button_colorsModal"
            },
            okCancel: true,
            onOk() {
                modal.destroy();
                setEdit(false)
                setEditField(false)
                dispatch(setEditCall(false));
                getData(invoiceId)
                scroolup()
                CloseDrawer()
            },
            onCancel() {
                onSubmitApiCall(values)
            },
        });
    };
    const onSubmit = async (values) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDoubleClick(true)
        if (!Billing) {
            message.error("Please enter the billing address");
            return;
        }
        if (!Shipping) {
            message.error("Please enter the shipping address");
            return;
        }
        const { subject, number, InOwner, sonumber, prnumber, qnumber, balanceAmount, paidAmount, paymentStatus, status, deal, account, exciseduty, salescommision, contact, description, termsandCondition } = values;
        const hasErrors = Object.values(errors).some(error => error === true);
        if (hasErrors) {
            message.error("Please fill out all required fields")
            scroolup()
            return;
        }
        const convertedData = await Promise.all(
            items.map(async (role) => {
                const convertedRate = await (role.value !== undefined && role.value !== null && role.value !== ""
                    ? convertCurrency(ConvertRate, Number(role.value))
                    : role.value);
                const convertedTotalValue = await (role.total !== undefined && role.total !== null && role.total !== "" ?
                    convertCurrency(ConvertRate, Number(role.total))
                    : role.total);
                return {
                    ...role,
                    value: convertedRate,
                    total: convertedTotalValue,
                };
            })
        );
        const SalesCommision = salescommision
            ? await convertCurrency(ConvertRate, Number(salescommision))
            : salescommision;
        const ExciseDuty = exciseduty
            ? await convertCurrency(ConvertRate, Number(exciseduty))
            : exciseduty;
        const subtotals = total ? await convertCurrency(ConvertRate, Number(total)) : total;
        const adjustments = adjustment ? await convertCurrency(ConvertRate, Number(adjustment)) : adjustment;
        const shippingssss = (shippingss && shippingss !== "") ? await convertCurrency(ConvertRate, Number(shippingss)) : 0;
        const totals = grandTotal ? await convertCurrency(ConvertRate, Number(grandTotal)) : grandTotal;
        const paidAmounttotals = paidAmount ? await convertCurrency(ConvertRate, Number(paidAmount)) : paidAmount;
        const balanceAmounttotals = balanceAmount ? await convertCurrency(ConvertRate, Number(balanceAmount)) : balanceAmount;
        const InvoiceItems = {
            item: convertedData,
            subtotalamount: subtotals,
            discountamount: dealDiscount,
            taxAmount: tax,
            shippingamount: shippingssss,
            adjustmentAmount: adjustments,
            grandTotalamount: totals,
            dealData: dealType
        }
        const payload =
        {
            invoiceName: subject,
            invoiceNumber: number,
            invoiceOwner: InOwner,
            salesOrderId: sonumber,
            purchaseOrderNumber: prnumber,
            quoteId: qnumber,
            invoiceStatus: status,
            accountId: account,
            dealId: deal,
            conatctId: contact,
            dueDate: DueDate,
            invoiceDate: InvoiceDate,
            salesCommision: SalesCommision,
            exciseDuty: ExciseDuty,
            billingAddress,
            shippingAddress: shipingAddress,
            invoiceItem: InvoiceItems,
            termsAndCondition: termsandCondition,
            description,
            grantTotal: totals,
            paymentStatus: InvoiceStatus === "Paid" ? paymentStatus : null,
            paidAmount: InvoiceStatus === "Paid" ? paidAmounttotals : null,
            balanceAmount: InvoiceStatus === "Paid" ? balanceAmounttotals : null,
            uploadFile: FILEList,
        }
        if (FromPage === "EntityUpdate") {
            if (displayData.invoiceStatus === "Delivered" && (payload.invoiceStatus !== "Created" && payload.invoiceStatus !== "Approved")) {
                const hasChanges = !deepEqual(displayData, payload, ["invoiceStatus"]);
                if (hasChanges) {
                    showConfirmForAccount(payload)
                }
                else {
                    onSubmitApiCall(payload)
                }
            }
            else {
                onSubmitApiCall(payload)
            }
        }
        else {
            onSubmitApiCall(payload)
        }
    }
    const getRefreshtheTable = () => {
        setEdit(false)
        setEditField(false)
        dispatch(setEditCall(false));
        getData(invoiceId)
        scroolup()
        CloseDrawer()
    }
    const handleChangestatus = (value) => {
        setInvoiceStatus(value)
        if (value === "Paid") {
            setPaymentStatus("Fully Paid")
            form.setFieldsValue({
                paymentStatus: "Fully Paid",
                paidAmount: grandTotal,
                balanceAmount: 0,
            });
        }
        else {
            setPaymentStatus()
            form.setFieldsValue({
                paymentStatus: null,
                paidAmount: null,
                balanceAmount: null
            });
        }
    }
    return (
        <>
            {FromPage === "EntityUpdate" ?
                <Main>
                    {displayData ? <>
                        {FromPage === "EntityUpdate" &&
                            <DetailsPage PageCancel={PageCancel} handleEditChange={handleEditChange} moreAction={moreAction}
                                DetailsPageMoreAction={<MoreAction />} ButtonActions={ButtonActions} Maincontent={LeadInfos} UpdateDataPage={undefined}
                                EntityTabDetails={LeadDetails} EntityRelatedTab={RelatedDetails} RightRelatedDetails={RightRelatedDetails}
                            />}
                    </>
                        :
                        <div className="spin">
                            <Spin />
                        </div>}
                </Main> : <></>}
            <Drawer
                className='Drawer-Header-Pages'
                bodyStyle={{ padding: 0 }}
                title={
                    FromPage === "EntityUpdate" ?
                        <span>
                            Update Invoice
                            {displayData?.invoiceName && (
                                <>
                                    <span style={{
                                        margin: '0 10px',
                                        color: '#d9d9d9',
                                        fontWeight: 'normal'
                                    }}>|</span>
                                    <span style={{ fontWeight: 'normal' }}>
                                        {displayData?.invoiceName}
                                    </span>
                                </>
                            )}
                        </span>
                        : "Create Invoice"
                }
                closable={false}
                placement="right"
                open={editField}
                width="80%"
                extra={
                    <Space>
                        {!edit ?
                            <div className='Hover-Refresh2 back-hover1 able-style'
                                role="button"
                                tabIndex={0} title='Edit'
                                onClick={() => EditOpenForDrawer()}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        EditOpenForDrawer()
                                    }
                                }}
                                aria-label='edit'
                            > <EditIcon height={20} width={20} /></div> : <></>}
                        <div className='Hover-Refresh2 back-hover1 able-style'
                            role="button"
                            tabIndex={0} title='Close'
                            onClick={() => PageCancel1()}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    PageCancel1()
                                }
                            }}
                            aria-label='Close'
                        > <CancelIcon width={24} height={24} /></div>
                    </Space>
                }
                footer={
                    (uiReady && edit) ? [
                        <div className="form_action_button">
                            <Button
                                className="gray-button" size="small"
                                onClick={() => PageCancel1()}
                            >
                                <CancelIcon height={25} width={25} />Cancel
                            </Button>
                            {FromPage === "EntityUpdate" ?
                                <Button
                                    className="red-button" size="small"
                                    onClick={() => OnClickofDelete(invoiceId)}
                                >
                                    <DeleteIcon height={25} width={25} />Delete
                                </Button> : <></>}
                            <Button size="small" htmlType="submit" className="button_colors" onClick={() => form.submit()} loading={doubleClick} disabled={doubleClick}>
                                {!doubleClick && <SaveIcon height={25} width={25} />}{FromPage === "EntityUpdate" ? "Update" : "Save"}
                            </Button>
                        </div>] : false
                }
            >
                {(uiReady && displayData) ? <Scrollbars autoHide autoHideTimeout={500} autoHideDuration={200}>
                    <AddUser>
                        <div className="user-info-form">
                            <Form style={{ width: '100%' }} form={form} name="info" onFinish={onSubmit} onFinishFailed={onFinishFailed} colon={false}>
                                <BasicFormWrapper>
                                    <VerticalFormStyleWrap>
                                        <div className="add-product-block">
                                            <div style={{ margin: 40 }}>
                                                <Row gutter={15}>
                                                    <Col xs={24}>
                                                        <div className="add-product-content">
                                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                                <Heading as="h5">Basic Information</Heading>
                                                                {UrlId !== undefined && UrlId !== null && UrlId[0] === "?INVOICE" &&
                                                                    // <Dropdown placement="bottomLeft" size="small" content={content}>
                                                                    //     <FeatherIcon icon="more-vertical" size={25} style={{ marginTop: 6 }} />
                                                                    // </Dropdown>
                                                                    <div role="button" className="Hover-Refresh2 back-hover1 able-style" tabIndex={0}
                                                                        onClick={edit ? () => { getSalesOrderData({ SalesORId: displayData?.salesOrderId }); setItems([]) } : undefined}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                                getSalesOrderData({ SalesORId: displayData?.salesOrderId });
                                                                                setItems([])
                                                                            }
                                                                        }}>
                                                                        <QUSOINIcon height={16} width={16} marginRight={5} /> Sync with Tenancy Agreement
                                                                    </div>
                                                                }
                                                            </div>
                                                            <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Invoice Name" name="subject" id="subject" rules={edit ? [{ required: true, message: 'Please enter invoice name' }, {
                                                                        validator: (_, value) => {
                                                                            const error = validateShortText(value, 50);
                                                                            if (error) {
                                                                                return Promise.reject(new Error(error));
                                                                            }
                                                                            return Promise.resolve();
                                                                        },
                                                                    }] : [{ required: false }]}>
                                                                        {edit ? <Input placeholder="Enter Invoice Name" /> :
                                                                            <span>{displayData?.invoiceName}</span>
                                                                        }
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Invoice Number" name="number" id="number" rules={edit ? [{ required: true, message: 'Please enter invoice number' }, { validator: validateCode }] : [{ required: false }]}>
                                                                        {edit ? <Input placeholder="Enter Invoice Number" /> :
                                                                            <span>{displayData?.invoiceNumber}</span>
                                                                        }
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Invoice Owner" name="InOwner" id="InOwner" rules={edit ? [{ required: true, message: 'Please select owner' }] : [{ required: false }]}>
                                                                        {edit ? <Select style={{ width: '100%' }}
                                                                            placeholder="Select Invoice Owner"
                                                                            showSearch optionLabelProp="label"
                                                                            filterOption={(input, option) => {
                                                                                const usernameElement = option.children.props.children[1].props.children[0];
                                                                                if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                    const username = String(usernameElement.props.children);
                                                                                    return username.toLowerCase().includes(input.toLowerCase());
                                                                                }
                                                                                return false;
                                                                            }
                                                                            }>
                                                                            {users}
                                                                        </Select> :
                                                                            <span className='user-info_image ListNavigate'
                                                                                role="button"
                                                                                tabIndex={0}
                                                                                onClick={() => displayData?.invoiceOwner && ViewDetailPage(displayData?.invoiceOwner, "USER")}
                                                                                onKeyDown={(event) => {
                                                                                    if (event.key === 'Enter' || event.key === ' ') {
                                                                                        ViewDetailPage(displayData?.invoiceOwner, "USER");
                                                                                    }
                                                                                }}
                                                                            >{displayData?.invoiceOwner && (
                                                                                displayData?.invoiceOwnerProfilePic !== null && displayData?.invoiceOwnerProfilePic
                                                                                    !== undefined && displayData?.invoiceOwnerProfilePic !== "" ?
                                                                                    <figure>
                                                                                        <img style={{ width: "30px", height: "30px" }} src={displayData?.invoiceOwnerProfilePic} alt="" />
                                                                                    </figure>
                                                                                    :
                                                                                    <span className='list_span_Tag UserIcon'>
                                                                                        {displayData?.invoiceOwnerFirstName?.slice(0, 1).toUpperCase()}
                                                                                    </span>)
                                                                                }{displayData?.invoiceOwner && (
                                                                                    <figcaption>
                                                                                        {`${displayData?.invoiceOwnerFirstName} ${displayData?.invoiceOwnerLastName}`}
                                                                                    </figcaption>)}</span>
                                                                        }
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Tenancy Agreement Number" name="sonumber" id="sonumber" rules={edit ? [{ required: true, message: 'Please enter tenancy agreement number' }] : [{ required: false }]}>
                                                                        {edit ? <Select style={{ width: '100%' }} optionLabelProp="label" onChange={(value) => { getSalesOrderData({ SalesORId: value }); setItems([]) }} placeholder="Select Tenancy Agreement" showSearch optionFilterProp="children"
                                                                            filterOption={(input, option) => {
                                                                                const usernameElement = option.children.props.children[1].props.children[0];
                                                                                if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                    const username = String(usernameElement.props.children);
                                                                                    return username.toLowerCase().includes(input.toLowerCase());
                                                                                }
                                                                                return false;
                                                                            }
                                                                            }>
                                                                            {salesOrder?.filter(item => item.salesOrderStatus === "Delivered").map((option, i) => (
                                                                                <Option value={option.salesOrderId} key={i} label={(
                                                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                                        <div className='Div_flex2'>
                                                                                            <div className='share_image' title={`${option.salesOrderName} (${option.salesOrderNumber})`} style={{ cursor: "default" }}>
                                                                                                <span className="image_icon">
                                                                                                    {option.salesOrderName.slice(0, 1).toUpperCase()}
                                                                                                </span>
                                                                                                <span className='div-ellipsis'>{option.salesOrderName}</span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>)}>
                                                                                    <div className='UserList-dropdown' title={`${option.salesOrderName} (${option.salesOrderNumber})`}>
                                                                                        <div>
                                                                                            <span className='details_span_Tag' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                                {option.salesOrderName.slice(0, 1).toUpperCase()}
                                                                                            </span>
                                                                                        </div>
                                                                                        <div>
                                                                                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.salesOrderName}</p>
                                                                                            <p style={{ margin: 0 }}>{option.salesOrderNumber}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </Option>))}
                                                                        </Select> :
                                                                            <span className='user-info_image ListNavigate'
                                                                                role="button"
                                                                                tabIndex={0}
                                                                                onClick={() => displayData?.salesOrderId && ViewDetailPage(displayData?.salesOrderId, "SORDER")}
                                                                                onKeyDown={(event) => {
                                                                                    if (event.key === 'Enter' || event.key === ' ') {
                                                                                        ViewDetailPage(displayData?.salesOrderId, "SORDER");
                                                                                    }
                                                                                }}
                                                                            >{displayData?.salesOrderId &&
                                                                                `${displayData?.salesOrderName} (${displayData?.salesOrderNumber})`}
                                                                            </span>
                                                                        }
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Purchase Order Number" name="prnumber" id="prnumber" rules={edit ? [{ required: true, message: 'Please enter purchase order number' }] : [{ required: false }]}>
                                                                        {edit ? <Input placeholder="Enter Purchase Order Number" disabled /> :
                                                                            <span>{displayData?.purchaseOrderNumber}</span>
                                                                        }
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Quote Number" name="qnumber" id="qnumber" rules={edit ? [{ required: true, message: 'Please select quote number' }] : [{ required: false }]}>
                                                                        {edit ? <Select style={{ width: '100%' }} optionLabelProp="label" disabled placeholder="Select Quote Number" showSearch optionFilterProp="children"
                                                                            filterOption={(input, option) => {
                                                                                const usernameElement = option.children.props.children[1].props.children[0];
                                                                                if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                    const username = String(usernameElement.props.children);
                                                                                    return username.toLowerCase().includes(input.toLowerCase());
                                                                                }
                                                                                return false;
                                                                            }
                                                                            }>
                                                                            {QuotesData?.filter(item => item.quotesStatus === "Delivered").map((option, i) => (
                                                                                <Option value={option.quotesId} key={i} label={(
                                                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                                        <div className='Div_flex2'>
                                                                                            <div className='share_image' title={`${option.quotesName} (${option.quotesNumber})`} style={{ cursor: "default" }}>
                                                                                                <span className="image_icon">
                                                                                                    {option.quotesName.slice(0, 1).toUpperCase()}
                                                                                                </span>
                                                                                                <span className='div-ellipsis'>{option.quotesName}</span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>)}>
                                                                                    <div className='UserList-dropdown' title={`${option.quotesName} (${option.quotesNumber})`}>
                                                                                        <div>
                                                                                            <span className='details_span_Tag' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                                {option.quotesName.slice(0, 1).toUpperCase()}
                                                                                            </span>
                                                                                        </div>
                                                                                        <div>
                                                                                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.quotesName}</p>
                                                                                            <p style={{ margin: 0 }}>{option.quotesNumber}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </Option>))}
                                                                        </Select> :
                                                                            <span className='user-info_image ListNavigate'
                                                                                role="button"
                                                                                tabIndex={0}
                                                                                onClick={() => displayData?.quoteId && ViewDetailPage(displayData?.quoteId, "QUOTES")}
                                                                                onKeyDown={(event) => {
                                                                                    if (event.key === 'Enter' || event.key === ' ') {
                                                                                        ViewDetailPage(displayData?.quoteId, "QUOTES");
                                                                                    }
                                                                                }}
                                                                            >{displayData?.quoteId &&
                                                                                `${displayData?.quotesName} (${displayData?.quotesNumber})`}
                                                                            </span>
                                                                        }
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }} >
                                                                    <Form.Item label="Invoice Status" name="status" id="status" rules={edit ? [{ required: true, message: 'Please select status' }] : [{ required: false }]} >
                                                                        {edit ? <Select style={{ width: '100%' }} placeholder="Enter Select Invoice Status" onChange={(value) => handleChangestatus(value)}>
                                                                            <Option value="Created">Created</Option>
                                                                            <Option value="Approved">Approved</Option>
                                                                            <Option value="Delivered">Delivered</Option>
                                                                            <Option value="Paid">Paid</Option>
                                                                            <Option value="Cancelled">Cancelled</Option>
                                                                        </Select> :
                                                                            <span>{displayData?.invoiceStatus}</span>
                                                                        }
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Sponsor Name" name="account" id="account" rules={edit ? [{ required: true, message: 'Please select sponsor' }] : [{ required: false }]}>
                                                                        {edit ?
                                                                            <Select style={{ width: '100%' }}
                                                                                placeholder="Select Sponsor"
                                                                                showSearch disabled optionLabelProp="label"
                                                                                optionFilterProp="children"
                                                                                filterOption={(input, option) => {
                                                                                    const usernameElement = option.children.props.children[1].props.children[0];
                                                                                    if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                        const username = String(usernameElement.props.children);
                                                                                        return username.toLowerCase().includes(input.toLowerCase());
                                                                                    }
                                                                                    return false;
                                                                                }
                                                                                }
                                                                            >
                                                                                {account}
                                                                            </Select>
                                                                            : <span className='user-info_image ListNavigate'
                                                                                role="button"
                                                                                tabIndex={0}
                                                                                onClick={() => displayData?.accountId && ViewDetailPage(displayData?.accountId, "ACCOUNT")}
                                                                                onKeyDown={(event) => {
                                                                                    if (event.key === 'Enter' || event.key === ' ') {
                                                                                        ViewDetailPage(displayData?.accountId, "ACCOUNT");
                                                                                    }
                                                                                }}
                                                                            >{displayData?.accountId && (
                                                                                displayData?.accountProfile !== null && displayData?.accountProfile
                                                                                    !== undefined && displayData?.accountProfile !== "" ?
                                                                                    <figure>
                                                                                        <img style={{ width: "30px", height: "30px" }} src={displayData?.accountProfile} alt="" />
                                                                                    </figure>
                                                                                    :
                                                                                    <span className='list_span_Tag AccountIcon'>
                                                                                        {displayData?.accountName?.slice(0, 1).toUpperCase()}
                                                                                    </span>)
                                                                                }{displayData?.accountId && (
                                                                                    <figcaption>
                                                                                        {displayData?.accountName} ({displayData?.accountNumber})
                                                                                    </figcaption>)}</span>
                                                                        }
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Proposal Name" name="deal" id="deal" rules={edit ? [{ required: true, message: 'Please select proposal' }] : [{ required: false }]}>
                                                                        {edit ? <Select style={{ width: '100%' }}
                                                                            placeholder="Select Proposal"
                                                                            showSearch optionLabelProp="label"
                                                                            disabled
                                                                            optionFilterProp="children"
                                                                            filterOption={(input, option) => {
                                                                                const usernameElement = option.children.props.children[1].props.children[0];
                                                                                if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                    const username = String(usernameElement.props.children);
                                                                                    return username.toLowerCase().includes(input.toLowerCase());
                                                                                }
                                                                                return false;
                                                                            }
                                                                            }
                                                                        >{deal}
                                                                        </Select>
                                                                            :
                                                                            <span className='user-info_image ListNavigate'
                                                                                role="button"
                                                                                tabIndex={0}
                                                                                onClick={() => displayData?.dealId && ViewDetailPage(displayData?.dealId, "DEAL")}
                                                                                onKeyDown={(event) => {
                                                                                    if (event.key === 'Enter' || event.key === ' ') {
                                                                                        ViewDetailPage(displayData?.dealId, "DEAL");
                                                                                    }
                                                                                }}
                                                                            >{displayData?.dealId && (
                                                                                displayData?.dealProfile !== null && displayData?.dealProfile
                                                                                    !== undefined && displayData?.dealProfile !== "" ?
                                                                                    <figure>
                                                                                        <img style={{ width: "30px", height: "30px" }} src={displayData?.dealProfile} alt="" />
                                                                                    </figure>
                                                                                    :
                                                                                    <span className='list_span_Tag DealIcon'>
                                                                                        {displayData?.dealName?.slice(0, 1).toUpperCase()}
                                                                                    </span>)
                                                                                }{displayData?.dealId && (
                                                                                    <figcaption>
                                                                                        {displayData?.dealName}
                                                                                    </figcaption>)}</span>}
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Resident Name" name="contact" id="contact" rules={edit ? [{ required: true, message: 'Please select resident' }] : [{ required: false }]}>
                                                                        {edit ? <Select style={{ width: '100%' }}
                                                                            placeholder="Select Resident Name"
                                                                            showSearch optionLabelProp="label"
                                                                            optionFilterProp="children"
                                                                            filterOption={(input, option) => {
                                                                                const usernameElement = option.children.props.children[1].props.children[0];
                                                                                if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                    const username = String(usernameElement.props.children);
                                                                                    return username.toLowerCase().includes(input.toLowerCase());
                                                                                }
                                                                                return false;
                                                                            }
                                                                            }
                                                                            onChange={(value) => onChangeContact(value)}
                                                                        >
                                                                            {contact}
                                                                        </Select> : <span className='user-info_image ListNavigate'
                                                                            role="button"
                                                                            tabIndex={0}
                                                                            onClick={() => displayData?.caseCreater && ViewDetailPage(displayData?.caseCreater, "CONTACT")}
                                                                            onKeyDown={(event) => {
                                                                                if (event.key === 'Enter' || event.key === ' ') {
                                                                                    ViewDetailPage(displayData?.caseCreater, "CONTACT");
                                                                                }
                                                                            }}
                                                                        >{displayData?.conatctId && (
                                                                            displayData?.contactprofilePic !== null && displayData?.contactprofilePic
                                                                                !== undefined && displayData?.contactprofilePic !== "" ?
                                                                                <figure>
                                                                                    <img style={{ width: "30px", height: "30px" }} src={displayData?.contactprofilePic} alt="" />
                                                                                </figure>
                                                                                :
                                                                                <span className='list_span_Tag ContactIcon'>
                                                                                    {displayData?.contactFirstName?.slice(0, 1).toUpperCase()}
                                                                                </span>)
                                                                            }{displayData?.conatctId && (
                                                                                <figcaption>
                                                                                    {`${displayData?.contactFirstName} ${displayData?.contactLastName}`}
                                                                                </figcaption>)}</span>
                                                                        }
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label={`Sales Commision (${currencySettings?.currency})`} name="salescommision" id="salescommision" rules={[{
                                                                        validator: async (_, value) => {
                                                                            if (value === undefined || value === null || value === '') {
                                                                                return Promise.resolve();
                                                                            }
                                                                            // Strict numeric check (digits with optional 1 dot)
                                                                            const basicNumberCheck = /^\d+(\.\d*)?$/;
                                                                            if (!basicNumberCheck.test(value)) {
                                                                                return Promise.reject(new Error('Please enter a valid number'));
                                                                            }

                                                                            // Check decimal places (must be ≤ 2)
                                                                            const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${currencySettings?.decimalOfCurrency}})?$`);
                                                                            if (!decimalRegex.test(value)) {
                                                                                return Promise.reject(
                                                                                    new Error(`Only up to ${currencySettings?.decimalOfCurrency} decimal place${currencySettings?.decimalOfCurrency > 1 ? 's' : ''} are allowed`)
                                                                                );
                                                                            }

                                                                            return Promise.resolve();
                                                                        }

                                                                    }]}>
                                                                        {edit ? <Input placeholder="Enter Sales Commision" onBlur={(e) => {
                                                                            if (e.target.value === '') {
                                                                                form.setFieldsValue({ salescommision: 0 });
                                                                            }
                                                                        }} prefix={currencySettings?.symbol} /> :
                                                                            <span>{displayData?.salesCommision && currencySettings?.symbol} {displayData?.salesCommision}</span>
                                                                        }
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label={`Excise Duty (${currencySettings?.currency})`} name="exciseduty" id="exciseduty" rules={[{
                                                                        validator: async (_, value) => {
                                                                            if (value === undefined || value === null || value === '') {
                                                                                return Promise.resolve();
                                                                            }
                                                                            // Strict numeric check (digits with optional 1 dot)
                                                                            const basicNumberCheck = /^\d+(\.\d*)?$/;
                                                                            if (!basicNumberCheck.test(value)) {
                                                                                return Promise.reject(new Error('Please enter a valid number'));
                                                                            }

                                                                            // Check decimal places (must be ≤ 2)
                                                                            const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${currencySettings?.decimalOfCurrency}})?$`);
                                                                            if (!decimalRegex.test(value)) {
                                                                                return Promise.reject(
                                                                                    new Error(`Only up to ${currencySettings?.decimalOfCurrency} decimal place${currencySettings?.decimalOfCurrency > 1 ? 's' : ''} are allowed`)
                                                                                );
                                                                            }

                                                                            return Promise.resolve();
                                                                        }

                                                                    }]}>
                                                                        {edit ? <Input placeholder="Enter Excise Duty" onBlur={(e) => {
                                                                            if (e.target.value === '') {
                                                                                form.setFieldsValue({ exciseduty: 0 });
                                                                            }
                                                                        }} prefix={currencySettings?.symbol} /> :
                                                                            <span>{displayData?.exciseDuty && currencySettings?.symbol} {displayData?.exciseDuty}</span>
                                                                        }
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Invoice Date" name="invoicedate" id="invoicedate" dependencies={["date"]} rules={edit ? [{ required: true, message: 'Please select invoice date' },
                                                                    ({ getFieldValue }) => ({
                                                                        validator(_, value) {
                                                                            const endDate = getFieldValue("date");
                                                                            if (!value || !endDate || value <= endDate) {
                                                                                return Promise.resolve();
                                                                            }
                                                                            return Promise.reject(new Error("Invoice date cannot be after due date"));
                                                                        },
                                                                    })
                                                                    ] : [{ required: false }]}>
                                                                        {edit ? <DatePicker allowClear={false}
                                                                            format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                                                            onChange={invoiceDateChange}
                                                                            disabledDate={disabledDate}
                                                                        /> : <span >
                                                                            {displayData !== undefined && displayData.invoiceDate ? moment(displayData !== undefined && displayData.invoiceDate).format(profile.dateFormate) : (displayData !== undefined && displayData.invoiceDate && moment(displayData !== undefined && displayData.invoiceDate).format("YYYY-MM-DD"))}
                                                                        </span>}
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Due Date" name="date" id="date" dependencies={["invoicedate"]} rules={edit ? [{ required: true, message: 'Please select due date' },
                                                                    ({ getFieldValue }) => ({
                                                                        validator(_, value) {
                                                                            const startDate = getFieldValue("invoicedate");
                                                                            if (!value || !startDate || value >= startDate) {
                                                                                return Promise.resolve();
                                                                            }
                                                                            return Promise.reject(new Error("Due date cannot be before invoice date"));
                                                                        },
                                                                    })
                                                                    ] : [{ required: false }]}>
                                                                        {edit ? <DatePicker allowClear={false}
                                                                            format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                                                            onChange={DueDateChange}
                                                                            disabledDate={disabledDate} /> : <span >
                                                                            {displayData !== undefined && displayData.dueDate ? moment(displayData !== undefined && displayData.dueDate).format(profile.dateFormate) : (displayData !== undefined && displayData.dueDate && moment(displayData !== undefined && displayData.dueDate).format("YYYY-MM-DD"))}
                                                                        </span>}
                                                                    </Form.Item>
                                                                </Col>
                                                            </Row>
                                                            {InvoiceStatus === "Paid" &&
                                                                <>
                                                                    <Heading as="h5">Payment details </Heading>
                                                                    <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                        <Col span={8} style={{ marginBottom: 20 }}>
                                                                            <Form.Item label="Payment Status" name="paymentStatus" id="paymentStatus" rules={edit ? [{ required: true, message: 'Please select payment status' }] : [{ required: false }]} >
                                                                                {edit ? <Select style={{ width: '100%' }} placeholder="Enter Select Payment Status" onChange={(value) => handlePaymentchange(value)}>
                                                                                    <Option value="Partially Paid">Partially Paid</Option>
                                                                                    <Option value="Fully Paid">Fully Paid</Option>
                                                                                </Select> :
                                                                                    <span>{displayData?.paymentStatus}</span>
                                                                                }
                                                                            </Form.Item>
                                                                        </Col>
                                                                        <Col span={8} style={{ marginBottom: 20 }}>
                                                                            <Form.Item label={`Paid Amount (${currencySettings?.currency})`} name="paidAmount" id="paidAmount" rules={edit ? [{ required: true, message: 'Please enter paid amount' },
                                                                            {
                                                                                validator: async (_, value) => {
                                                                                    if (value === undefined || value === null || value === '') {
                                                                                        return Promise.resolve();
                                                                                    }
                                                                                    // Strict numeric check (digits with optional 1 dot)
                                                                                    const basicNumberCheck = /^\d+(\.\d*)?$/;
                                                                                    if (!basicNumberCheck.test(value)) {
                                                                                        return Promise.reject(new Error('Please enter a valid number'));
                                                                                    }

                                                                                    // Check decimal places (must be ≤ 2)
                                                                                    const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${currencySettings?.decimalOfCurrency}})?$`);
                                                                                    if (!decimalRegex.test(value)) {
                                                                                        return Promise.reject(
                                                                                            new Error(`Only up to ${currencySettings?.decimalOfCurrency} decimal place${currencySettings?.decimalOfCurrency > 1 ? 's' : ''} are allowed`)
                                                                                        );
                                                                                    }

                                                                                    return Promise.resolve();
                                                                                }

                                                                            }] : [{ required: false }]
                                                                            } >
                                                                                {edit ? <Input placeholder="Enter Paid Amount" onBlur={(e) => {
                                                                                    if (e.target.value === '') {
                                                                                        form.setFieldsValue({ paidAmount: 0 });
                                                                                    }
                                                                                }} prefix={currencySettings?.symbol} disabled={paymentStatus === "Fully Paid"} onChange={(e) => handlePaidChange(e.target.value)} /> :
                                                                                    <span> {displayData?.paidAmount && currencySettings?.symbol} {displayData?.paidAmount}</span>
                                                                                }
                                                                            </Form.Item>
                                                                        </Col>
                                                                        <Col span={8} style={{ marginBottom: 20 }}>
                                                                            <Form.Item label={`Balance Amount (${currencySettings?.currency})`} name="balanceAmount" id="balanceAmount" rules={edit ? [{ required: true, message: 'Please enter balance amount' }, {
                                                                                validator: async (_, value) => {
                                                                                    if (value === undefined || value === null || value === '') {
                                                                                        return Promise.resolve();
                                                                                    }
                                                                                    // Strict numeric check (digits with optional 1 dot)
                                                                                    const basicNumberCheck = /^\d+(\.\d*)?$/;
                                                                                    if (!basicNumberCheck.test(value)) {
                                                                                        return Promise.reject(new Error('Please enter a valid number'));
                                                                                    }

                                                                                    // Check decimal places (must be ≤ 2)
                                                                                    const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${currencySettings?.decimalOfCurrency}})?$`);
                                                                                    if (!decimalRegex.test(value)) {
                                                                                        return Promise.reject(
                                                                                            new Error(`Only up to ${currencySettings?.decimalOfCurrency} decimal place${currencySettings?.decimalOfCurrency > 1 ? 's' : ''} are allowed`)
                                                                                        );
                                                                                    }
                                                                                    return Promise.resolve();
                                                                                }
                                                                            }] : [{ required: false }]} >
                                                                                {edit ? <Input placeholder="Enter Balance Amount" onBlur={(e) => {
                                                                                    if (e.target.value === '') {
                                                                                        form.setFieldsValue({ balanceAmount: 0 });
                                                                                    }
                                                                                }} prefix={currencySettings?.symbol} disabled /> :
                                                                                    <span>{displayData?.balanceAmount && currencySettings?.symbol} {displayData?.balanceAmount}</span>
                                                                                }
                                                                            </Form.Item>
                                                                        </Col>
                                                                    </Row>
                                                                </>}
                                                            <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                <Col span={8}>
                                                                    <Heading as="h5"><span style={{ color: "red" }}><sup>* </sup></span>Billing Address</Heading>
                                                                    <Row gutter={30} style={{ marginBottom: 20, marginTop: 30 }}>

                                                                        <Col span={24} >
                                                                            {Billing ?
                                                                                <div className="addressCard" title="Edit Address"
                                                                                    style={{ cursor: edit ? "pointer" : "default" }}
                                                                                    role="button"
                                                                                    tabIndex={0}
                                                                                    onClick={() => edit ? addressPopup("Update", "Billing") : undefined}
                                                                                    onKeyDown={(event) => {
                                                                                        if (event.key === 'Enter' || event.key === ' ') {
                                                                                            addressPopup("Update", "Billing")
                                                                                        }
                                                                                    }}>
                                                                                    <div style={{ padding: "20px 20px 15px", lineHeight: "inherit" }}>
                                                                                        <div style={{ fontSize: "18px", fontWeight: "600" }}>{billingAddress?.name}</div>
                                                                                        <div>{billingAddress?.street}</div>
                                                                                        <div>{billingAddress?.city && `${billingAddress?.city}, `}{billingAddress?.state} {billingAddress?.zipcode}</div>
                                                                                        <div>{billingAddress?.country}</div>
                                                                                        <div style={{ fontSize: "14px", fontWeight: "600" }} className='ellipsisText' title={billingAddress?.email}>Email  : {billingAddress?.email}</div>
                                                                                        <div style={{ fontSize: "14px", fontWeight: "600" }} className='ellipsisText' title={billingAddress?.mobile}>Mobile : {billingAddress?.mobile}</div>
                                                                                    </div>
                                                                                </div>
                                                                                :
                                                                                edit &&
                                                                                <div className="addressCard" style={{
                                                                                    fontSize: 50,
                                                                                    width: "80%",
                                                                                    height: "175px",
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    justifyContent: "center"
                                                                                }}>
                                                                                    <PlusCircleOutlined style={{ color: "#7F7F7F" }} onClick={() => addressPopup("Create", "Billing")} />
                                                                                </div>
                                                                            }
                                                                        </Col>
                                                                    </Row >
                                                                </Col>
                                                                <Col span={8}>
                                                                    <Heading as="h5"><span style={{ color: "red" }}><sup>* </sup></span>Shipping Address</Heading>
                                                                    <Row gutter={30} style={{ marginBottom: 20, marginTop: 30 }}>

                                                                        <Col span={24}>
                                                                            {Billing && Shipping ?
                                                                                <div className="addressCard" title="Edit Address"
                                                                                    role="button" style={{ cursor: edit ? "pointer" : "default" }}
                                                                                    tabIndex={0}
                                                                                    onClick={() => edit ? addressPopup("Update", "Shipping") : undefined}
                                                                                    onKeyDown={(event) => {
                                                                                        if (event.key === 'Enter' || event.key === ' ') {
                                                                                            addressPopup("Update", "Shipping")
                                                                                        }
                                                                                    }}>
                                                                                    <div style={{ padding: "20px 20px 15px", lineHeight: "inherit" }}>
                                                                                        <div style={{ fontSize: "18px", fontWeight: "600" }}>{shipingAddress?.name}</div>
                                                                                        <div>{shipingAddress?.street}</div>
                                                                                        <div>{shipingAddress?.city && `${shipingAddress?.city}, `}{shipingAddress?.state} {shipingAddress?.zipcode}</div>
                                                                                        <div>{shipingAddress?.country}</div>
                                                                                        <div style={{ fontSize: "14px", fontWeight: "600" }} className='ellipsisText' title={shipingAddress?.email}>Email  : {shipingAddress?.email}</div>
                                                                                        <div style={{ fontSize: "14px", fontWeight: "600" }} className='ellipsisText' title={shipingAddress?.mobile}>Mobile : {shipingAddress?.mobile}</div>
                                                                                    </div>
                                                                                </div>
                                                                                :
                                                                                edit &&
                                                                                <div className="addressCard" style={{
                                                                                    fontSize: 50,
                                                                                    width: "80%",
                                                                                    height: "175px",
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    justifyContent: "center"
                                                                                }}>  <PlusCircleOutlined style={{ color: "#7F7F7F" }} onClick={() => Billing ? addressPopup("Create", "Shipping") : undefined} />
                                                                                </div>
                                                                            }
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                            <Heading as="h5">Invoice Items</Heading>
                                                            {items?.length > 0 ?
                                                                <>
                                                                    <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                        <div className="table-bordered leaderboard-table table-responsive QSITable" style={{ width: '100%' }}>
                                                                            <Table dataSource={items}
                                                                                columns={ProductColumns.slice(0, -1)}
                                                                                // columns={disableFileds ? ProductColumns : editableColumns} 
                                                                                pagination={false} />
                                                                        </div>
                                                                    </Row>
                                                                    <Row justify="end" style={{ marginBottom: 20 }}>
                                                                        <Col xxl={10} xl={10} lg={10} md={10} sm={18} xs={24} offset={0}>
                                                                            <OrderSummary style={{ maxWidth: 450 }}>
                                                                                <div className="invoice-summary-inner" >
                                                                                    <Row align="middle" gutter={30} style={{ marginBottom: 10 }}>
                                                                                        <Col lg={8} md={9} xs={24}>
                                                                                            <Form.Item label="Subtotal" />
                                                                                        </Col>
                                                                                        <Col lg={16} md={15} xs={24}>
                                                                                            <Form.Item label={`${currencySettings?.symbol} ${Number(total)?.toLocaleString()}`} />
                                                                                        </Col>
                                                                                    </Row>
                                                                                    <Row align="middle" gutter={30} style={{ marginBottom: 10 }}>
                                                                                        <Col lg={8} md={9} xs={24}>
                                                                                            <Form.Item label="Discount" />
                                                                                        </Col>
                                                                                        <Col lg={16} md={15} xs={24}>
                                                                                            <Form.Item>
                                                                                                <Input placeholder="Discount" prefix="%" value={dealDiscount} disabled={!edit}
                                                                                                    onChange={(e) => {
                                                                                                        const inputValue = e.target.value;
                                                                                                        const decimalLimit = currencySettings?.decimalOfCurrency || 2;
                                                                                                        const basicNumberCheck = /^\d*\.?\d*$/.test(inputValue);
                                                                                                        if (!basicNumberCheck) {
                                                                                                            message.error('Please enter a valid number');
                                                                                                            return;
                                                                                                        }
                                                                                                        if (inputValue === ".") {
                                                                                                            message.error('Please enter a valid number');
                                                                                                            return;
                                                                                                        }
                                                                                                        const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${decimalLimit}})?$`);
                                                                                                        if (inputValue && !decimalRegex.test(inputValue)) {
                                                                                                            message.error(`Only up to ${decimalLimit} decimal place${decimalLimit > 1 ? 's' : ''} are allowed`);
                                                                                                            return;
                                                                                                        }
                                                                                                        const num = Number(inputValue);
                                                                                                        if (inputValue && (num < 0 || num > 100)) {
                                                                                                            message.error('Percentage must be between 0 and 100');
                                                                                                            return;
                                                                                                        }
                                                                                                        setDealDiscount(inputValue);
                                                                                                    }} />
                                                                                            </Form.Item></Col>
                                                                                    </Row>
                                                                                    <Row align="middle" gutter={30} style={{ marginBottom: 10 }}>
                                                                                        <Col lg={8} md={9} xs={24}>
                                                                                            <Form.Item label="Tax" />
                                                                                        </Col>
                                                                                        <Col lg={16} md={15} xs={24}>
                                                                                            <Form.Item>
                                                                                                <Input placeholder="Tax" prefix="%" value={tax} disabled={!edit} onChange={(e) => {
                                                                                                    const inputValue = e.target.value;
                                                                                                    const decimalLimit = currencySettings?.decimalOfCurrency || 2;
                                                                                                    const basicNumberCheck = /^\d*\.?\d*$/.test(inputValue);
                                                                                                    if (!basicNumberCheck) {
                                                                                                        message.error('Please enter a valid number');
                                                                                                        return;
                                                                                                    }
                                                                                                    if (inputValue === ".") {
                                                                                                        message.error('Please enter a valid number');
                                                                                                        return;
                                                                                                    }
                                                                                                    const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${decimalLimit}})?$`);
                                                                                                    if (inputValue && !decimalRegex.test(inputValue)) {
                                                                                                        message.error(`Only up to ${decimalLimit} decimal place${decimalLimit > 1 ? 's' : ''} are allowed`);
                                                                                                        return;
                                                                                                    }
                                                                                                    const num = Number(inputValue);
                                                                                                    if (inputValue && (num < 0 || num > 100)) {
                                                                                                        message.error('Percentage must be between 0 and 100');
                                                                                                        return;
                                                                                                    }
                                                                                                    setTax(inputValue);
                                                                                                }} />
                                                                                            </Form.Item></Col>
                                                                                    </Row>
                                                                                    <Row align="middle" gutter={30} style={{ marginBottom: 10 }}>
                                                                                        <Col lg={8} md={9} xs={24}>
                                                                                            <Form.Item label="Adjustment" />
                                                                                        </Col>
                                                                                        <Col lg={16} md={15} xs={24}>
                                                                                            <Form.Item>  <Input placeholder="Adjustment" disabled={!edit} prefix={currencySettings?.symbol} value={adjustment} onChange={(e) => {
                                                                                                const inputValue = e.target.value;
                                                                                                const decimalLimit = currencySettings?.decimalOfCurrency || 2;
                                                                                                const basicNumberCheck = /^\d*\.?\d*$/.test(inputValue);
                                                                                                if (!basicNumberCheck) {
                                                                                                    message.error('Please enter a valid number');
                                                                                                    return;
                                                                                                }
                                                                                                if (inputValue === ".") {
                                                                                                    message.error('Please enter a valid number');
                                                                                                    return;
                                                                                                }
                                                                                                const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${decimalLimit}})?$`);
                                                                                                if (inputValue && !decimalRegex.test(inputValue)) {
                                                                                                    message.error(`Only up to ${decimalLimit} decimal place${decimalLimit > 1 ? 's' : ''} are allowed`);
                                                                                                    return;
                                                                                                }
                                                                                                setAdjustment(inputValue)
                                                                                            }} />
                                                                                            </Form.Item></Col>
                                                                                    </Row>
                                                                                    <Row align="middle" gutter={30} style={{ marginBottom: 10 }}>
                                                                                        <Col lg={8} md={9} xs={24}>
                                                                                            <Form.Item label="Shipping/Handling" />
                                                                                        </Col>
                                                                                        <Col lg={16} md={15} xs={24}>
                                                                                            <Form.Item> <Input placeholder="Shipping/Handling" disabled={!edit} prefix={currencySettings?.symbol} value={shippingss} onChange={(e) => {
                                                                                                const inputValue = e.target.value;
                                                                                                const decimalLimit = currencySettings?.decimalOfCurrency || 2;
                                                                                                const basicNumberCheck = /^\d*\.?\d*$/.test(inputValue);
                                                                                                if (!basicNumberCheck) {
                                                                                                    message.error('Please enter a valid number');
                                                                                                    return;
                                                                                                }
                                                                                                if (inputValue === ".") {
                                                                                                    message.error('Please enter a valid number');
                                                                                                    return;
                                                                                                }
                                                                                                const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${decimalLimit}})?$`);
                                                                                                if (inputValue && !decimalRegex.test(inputValue)) {
                                                                                                    message.error(`Only up to ${decimalLimit} decimal place${decimalLimit > 1 ? 's' : ''} are allowed`);
                                                                                                    return;
                                                                                                }
                                                                                                setShipping(inputValue)
                                                                                            }} />
                                                                                            </Form.Item></Col>
                                                                                    </Row>
                                                                                    <Row align="middle" gutter={30} style={{ marginBottom: 10 }}>
                                                                                        <Col lg={8} md={9} xs={24}>
                                                                                            <Form.Item label="Grand Total" />
                                                                                        </Col>
                                                                                        <Col lg={16} md={15} xs={24}>
                                                                                            <Form.Item label={`${currencySettings?.symbol} ${Number(grandTotal)?.toLocaleString()}`} />
                                                                                        </Col>
                                                                                    </Row>
                                                                                </div>
                                                                            </OrderSummary>
                                                                        </Col>
                                                                    </Row>
                                                                </> : <Row gutter={30} style={{ margin: "20px 0px" }} />}
                                                            <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                <Col span={24} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Terms and Condition" name="termsandCondition" id="termsandCondition" rules={
                                                                        [
                                                                            {
                                                                                validator: (_, value) => {
                                                                                    const error = validateDescriptionField(value, 2500);
                                                                                    if (error) {
                                                                                        return Promise.reject(new Error(error));
                                                                                    }
                                                                                    return Promise.resolve();
                                                                                },
                                                                            },
                                                                        ]
                                                                    }>
                                                                        {edit ? <Input.TextArea rows={3} maxLength={2500} showCount placeholder='Enter Terms and Condition' />
                                                                            : <span>{displayData?.termsAndCondition}</span>
                                                                        }
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={24} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Description" name="description" id="description" rules={
                                                                        [
                                                                            {
                                                                                validator: (_, value) => {
                                                                                    const error = validateDescriptionField(value, 2500);
                                                                                    if (error) {
                                                                                        return Promise.reject(new Error(error));
                                                                                    }
                                                                                    return Promise.resolve();
                                                                                },
                                                                            },
                                                                        ]
                                                                    }>
                                                                        {edit ? <Input.TextArea rows={3} maxLength={2500} showCount placeholder='Enter Description' /> : <span>{displayData?.description}</span>}
                                                                    </Form.Item>
                                                                </Col>
                                                            </Row>
                                                            <RelatedDocUpload edit={edit} FILEList={FILEList} setFileList={setFileList} form={form} />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    </VerticalFormStyleWrap>
                                </BasicFormWrapper>
                            </Form>
                        </div>
                    </AddUser>
                </Scrollbars> :
                    <div className="spin">
                        <Spin />
                    </div>}
            </Drawer >
            {isModalVisible1 && <UpdateConnectionPopup confirmPopup={isModalVisible1} setConfirmPopup={setIsModalVisible1} Respone={errorData} page="Details" type="Invoice" getCallBack={getRefreshtheTable} />}
            {cancelConfirmOpen && <AllCancelPopup confirmPopup={cancelConfirmOpen} setConfirmPopup={setCancelConfirmOpen} GetCallback={CloseDrawer} />}
            <ComposeMail mailOpen={mailOpen} close={closeMailComposr} entityName="invoice" entity="EntityPages" toId={[conatactDetails?.email]}
                AllData={{
                    data: displayData,
                    companyData,
                    tableItem: items,
                    tableColum: ProductColumns.slice(0, -1),
                    currencySettings, Calculation: { total, dealDiscount, tax, adjustment, shippingss, grandTotal }
                }} SubjectData={SubjectData} MailContent={MailContent} attachFile={attachFile} updateStatus={updateStatus} updateId={invoiceId} invoiceToken={UrlId ? UrlId[1] : null} />

            {confirmPopup && <ConfirmationPopup confirmPopup={confirmPopup} setConfirmPopup={setConfirmPopup} GetCallback={deleteMenu} deleteId={deleteId} />}
            {popupMessage && <DefaultMessagePopup messagePopup={popupMessage} setMessagePopup={setPopupMessage} pageType={pages} onNavigate={onnavigate} />}
            {popupOpen && <AddressPopup accountId={accountId} confirmPopup={popupOpen} setConfirmPopup={setPopupOpen} popupType={popupType} popupContent={popupContent} billingAddress={billingAddress} setBillingAddress={setBillingAddress} shipingAddress={shipingAddress} setShipingAddress={setShipingAddress} />}
        </>
    );
}
AddNew.propTypes = {
    UrlId: PropTypes.array.isRequired,
    FromPage: PropTypes.string.isRequired,
    setCratePage: PropTypes.func.isRequired,
    ShortCut: PropTypes.string.isRequired,
    GetAll: PropTypes.func.isRequired,
    dataForDeal: PropTypes.object.isRequired,
};

export default AddNew;
